import React, {useEffect} from "react";
import { Outlet } from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";
import Sidebar from "./components/PractitionerPortalLayout/Sidebar";
import "./styles/fonts.css";
import "./global.css";
import { useNavigate, useLocation } from 'react-router-dom';

const PractitionerLayout = () => {
    const isMobile = useMediaQuery("(max-width: 600px)");
    const navigate = useNavigate();
    const location = useLocation();
    const shouldShowHeaderFooter = !location.pathname.includes("/practitioner/newboard");

    useEffect(() => {
        const currentUserId = localStorage.getItem("LPCurrentUserId");
        if (!currentUserId) {
            navigate('/signup');;
        }
    }, [navigate]);
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box className={shouldShowHeaderFooter?"portalContainer":""}>
                {shouldShowHeaderFooter && <Sidebar />}
                <Box sx={{
                    marginLeft: shouldShowHeaderFooter ? isMobile ? 0 : "240px" : 0
                }}>
                    <Outlet />
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default PractitionerLayout;
